import React from 'react'
import Header from '../Components/Header/Header'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'
import OurFleets from '../Components/OurFleets/OurFleets'

const OurFleetsPage = () => {
  return (
    <>
    <Header/>
    <OurFleets/>
    <ContactUs/>
    <Footer/>
    
    </>
  )
}

export default OurFleetsPage